import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "c-workflow-rapid__inner" }
const _hoisted_3 = { class: "c-workflow-rapid__step-title" }
const _hoisted_4 = { class: "c-workflow-rapid__cards" }
const _hoisted_5 = { class: "c-workflow-rapid__info-card" }
const _hoisted_6 = {
  key: 0,
  class: "c-workflow-rapid__card-title"
}
const _hoisted_7 = {
  key: 1,
  class: "c-workflow-rapid__duration"
}
const _hoisted_8 = {
  key: 0,
  class: "c-workflow-rapid__duration-value"
}
const _hoisted_9 = {
  key: 1,
  class: "c-workflow-rapid__duration-unit"
}
const _hoisted_10 = { class: "c-workflow-rapid__process-card" }
const _hoisted_11 = {
  key: 0,
  class: "c-workflow-rapid__process-scroll"
}
const _hoisted_12 = { class: "c-workflow-rapid__process-row" }
const _hoisted_13 = { class: "c-workflow-rapid__process-item" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = {
  key: 2,
  class: "c-workflow-rapid__process-label"
}
const _hoisted_16 = {
  key: 0,
  class: "c-workflow-rapid__process-arrow",
  "aria-hidden": "true"
}

import { computed } from 'vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import type {
  WorkflowRapidProcessItemFields,
  WorkflowRapidProps,
  WorkflowRapidStepFields,
} from '@/types/components/WorkflowRapid';
import type { ScItem } from '@/types/sitecore';
import utils from '@/utils';

type WorkflowRapidStep = ScItem<WorkflowRapidStepFields> & { fields: WorkflowRapidStepFields };
type WorkflowRapidProcessItem = ScItem<WorkflowRapidProcessItemFields> & {
  fields: WorkflowRapidProcessItemFields;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'WorkflowRapid',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;
const fields = computed(() => props.fields);

const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'c-workflow-rapid'));
const rootStyle = computed(() => utils.overall?.baseComStyle?.(fields.value) || {});

const steps = computed<WorkflowRapidStep[]>(() => {
  const items = utils.sc.getFieldObj(fields.value, 'steps');
  return Array.isArray(items)
    ? items.filter((item): item is WorkflowRapidStep => Boolean(item?.fields?.title?.value))
    : [];
});

const processItems = computed<WorkflowRapidProcessItem[]>(() => {
  const items = utils.sc.getFieldObj(fields.value, 'processItems');
  return Array.isArray(items)
    ? items.filter((item): item is WorkflowRapidProcessItem => Boolean(item?.fields))
    : [];
});

const activeStepCount = computed(() => {
  const raw = Number(fields.value?.activeStepCount?.value ?? 0);
  return Number.isFinite(raw) ? Math.max(0, raw) : 0;
});

const timelineStyle = computed(() => {
  const count = Math.max(steps.value.length, 1);

  return {
    '--workflow-step-count': `${count}`,
    '--workflow-line-percent': `${50 / count}%`,
    '--workflow-line-tablet-offset': `${88 * (1 - 1 / count)}px`,
    '--workflow-line-desktop-offset': `${124 * (1 - 1 / count)}px`,
  };
});

const isStepActive = (step: WorkflowRapidStep, index: number) =>
  Boolean(step.fields.isActive?.value) || index < activeStepCount.value;

const getIconValue = (item: WorkflowRapidProcessItem) => {
  const icon = item.fields.icon?.value as
    | {
        src?: string;
        alt?: string;
        svgCode?: string;
        value?: {
          src?: string;
          alt?: string;
          svgCode?: string;
        };
      }
    | undefined;

  return icon?.value || icon || {};
};

const getIconSvg = (item: WorkflowRapidProcessItem) => getIconValue(item).svgCode || '';
const getIconSrc = (item: WorkflowRapidProcessItem) => getIconValue(item).src || '';
const getIconAlt = (item: WorkflowRapidProcessItem) =>
  getIconValue(item).alt || item.fields.label?.value || '';

return (_ctx: any,_cache: any) => {
  const _component_JssRichText = _resolveComponent("JssRichText")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(rootClass.value),
        style: _normalizeStyle(rootStyle.value),
        id: __props.rendering?.dataSource
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [2, 20],
          "tablet-default-grid": [1, 14],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_JssRichText, {
                class: "c-workflow-rapid__title",
                field: fields.value?.title,
                tag: "h2"
              }, null, 8, ["field"]),
              (steps.value.length)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "c-workflow-rapid__timeline",
                    style: _normalizeStyle(timelineStyle.value)
                  }, [
                    _cache[1] || (_cache[1] = _createElementVNode("span", {
                      class: "c-workflow-rapid__timeline-line",
                      "aria-hidden": "true"
                    }, null, -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step, index) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: step.id || step.fields.title?.value,
                        class: _normalizeClass(["c-workflow-rapid__step", { 'c-workflow-rapid__step--active': isStepActive(step, index) }])
                      }, [
                        _cache[0] || (_cache[0] = _createElementVNode("span", {
                          class: "c-workflow-rapid__dot",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _createElementVNode("h3", _hoisted_3, _toDisplayString(step.fields.title.value), 1)
                      ], 2))
                    }), 128))
                  ], 4))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("article", _hoisted_5, [
                  (fields.value.cardTitle?.value)
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_6, _toDisplayString(fields.value.cardTitle.value), 1))
                    : _createCommentVNode("", true),
                  (fields.value.durationValue?.value || fields.value.durationUnit?.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (fields.value.durationValue?.value)
                          ? (_openBlock(), _createElementBlock("strong", _hoisted_8, _toDisplayString(fields.value.durationValue.value), 1))
                          : _createCommentVNode("", true),
                        (fields.value.durationUnit?.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(fields.value.durationUnit.value), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (fields.value.bullets?.value)
                    ? (_openBlock(), _createBlock(_unref(RichText), {
                        key: 2,
                        class: "c-workflow-rapid__bullets",
                        field: fields.value.bullets
                      }, null, 8, ["field"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("article", _hoisted_10, [
                  (processItems.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processItems.value, (item, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: item.id || item.fields.label?.value
                            }, [
                              _createElementVNode("div", _hoisted_13, [
                                (getIconSvg(item))
                                  ? (_openBlock(), _createBlock(_component_Icon, {
                                      key: 0,
                                      class: "c-workflow-rapid__process-icon",
                                      svg: getIconSvg(item),
                                      "aria-hidden": "true"
                                    }, null, 8, ["svg"]))
                                  : (getIconSrc(item))
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        class: "c-workflow-rapid__process-icon",
                                        src: getIconSrc(item),
                                        alt: getIconAlt(item),
                                        loading: "lazy"
                                      }, null, 8, _hoisted_14))
                                    : _createCommentVNode("", true),
                                (item.fields.label?.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.fields.label.value), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              (index < processItems.value.length - 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ], 14, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})